import React, { useState } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { ReactComponent as F } from '../../icons/Flecha.svg';
import { ReactComponent as Burguer } from '../../icons/menu.svg';
import { ReactComponent as Icon } from '../../icons/legend.svg';

const appear = keyframes`
from {opacity: 0;}
to {opacity: 1;}
`;

const Back = styled.div`
  	position:fixed;
  	top: 0px;
  	left: 0px;
  	width: 100vw;
  	height: 100vh;
	padding: 0px;
	margin:   0px;
	background: rgba(0,0,0,0.7);
	color: #fff;
	pointer-events: all;
	z-index: 30;
}	
`;

const Container = styled.div`
	opacity: 0;
	${(props) =>
		props.show &&
		css`
			animation: ${appear} 1s ease;
			opacity: 1;
		`};
`;

const TCont = styled.div`
position:fixed;
  	top:${(props) => props.top + 'px'};
  	right: 80px;
	  font-weight: 700;
}	
`;

const Tt = styled.div`	
	background: #fff;
	font-weight: 700;
	color: #072B3B;
	line-height: 24px;
	padding: 8px 1rem;
	margin: 0px;
	border-radius: 0.5rem;
	float: left;

}	

`;
const Hamburguer = styled(Burguer)`
	position: fixed;
	top: 1rem;
	right: 1rem;
	width: 2rem;
	height: 2rem;
	background: #0397ab;
	fill: #fff;
	padding: 0.5rem;
	border-radius: 0.5rem;
`;

const Skip = styled.div`
	position: fixed;
	bottom: 5rem;
	right: 20vw;
	width: 60vw;
	text-align: center;
	padding: 1rem;
`;

const SkipButton = styled.a`
	bottom: 6rem;
	text-align: center;
	padding: 0.5rem 1rem;
	border: 1px solid #fff;
	border-radius: 8px;
`;

const FF = styled(F)`
	float: left;
	margin: ${(props) => Math.floor((props.h - 17) / 2) + 'px 0px'};
`;

export const UICont = styled.div`
  position: fixed
  right: 1rem;
  z-index: 19;
  top: calc(50vh - 90px);
`;

export const El = styled.div`
	clear: both;
	margin-bottom: 0.5rem;
`;

const LegendIcon = styled(Icon)`
	position: fixed;
	bottom: 1rem;
	right: 0.5rem;
	width: 48px;
	height: 48px;
`;

const Tooltip = ({ top, h, children }) => {
	return (
		<TCont top={top}>
			<Tt>{children}</Tt>
			<FF h={h} />
		</TCont>
	);
};

const WT = ({ next }) => {
	const [paso, setPaso] = useState(0);

	return (
		<Back onClick={() => (paso < 1 ? setPaso(paso + 1) : next(1))}>
			<Container show={paso === 0}>
				<Tooltip top={20} h={40}>
					Select a layer
				</Tooltip>
				<Hamburguer />
			</Container>

			<Container show={paso === 1}>
				<Tooltip top={window.innerHeight - 64} h={40}>
					Legend
				</Tooltip>
				<LegendIcon />
			</Container>

			<Skip>
				<SkipButton onClick={() => next(1)}> Skip instructions</SkipButton>{' '}
			</Skip>
		</Back>
	);
};

export default WT;
